
import { useEffect, useRef } from "react";
import { Userpilot } from "userpilot";

const handleSearchParamUpdate = (show: boolean, id: string | undefined) => {
  if (!id) return;

  const searchParams = new URLSearchParams(window.location.search);
  const cleanSearchParams = () => searchParams.delete(id);

  if (show) {
    searchParams.set(id, "true");
  } else {
    cleanSearchParams();
  }

  const queryParams = searchParams.toString();
  const newUrl = window.location.pathname + (!!queryParams ? `?${queryParams}` : "");
  window.history.replaceState(null, "", newUrl);
  Userpilot.reload();

  return cleanSearchParams;
}

export const useUserPilotSearchParams = (id: string | undefined, isShowing: boolean) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!id) return;
    // Every list-rendered instance (e.g. one Modal per product card) mounts with
    // isShowing=false. Skip the URL/history sync on that initial mount so mounting
    // many hidden instances at once doesn't trip the browser's history.replaceState throttle.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if (!isShowing) return;
    }
    return handleSearchParamUpdate(isShowing, id);
  }, [isShowing]);

  return handleSearchParamUpdate;
}